
import { Component, Vue } from 'vue-property-decorator'
import { fileSize, convertMilli } from '../../utils/services'
import moment from 'moment'

@Component
export default class HelperFormat extends Vue {

    get moment() {
        return moment
    }

    formatDate(date: any) {
        return moment(date).format('DD MMM YYYY hh:mm a')
    }

    // formatSize(filesize: any) {
    //     return fileSize(parseInt(filesize), {
    //         bits: true
    //     }).human()
    // }
    formatSize(filesize: any) {
        var thresh = 1000;
        if(Math.abs(filesize) < thresh) {
            return filesize + ' B';
        }
        var units = ['KB','MB','GB','TB','PB','EB','ZB','YB'];
        var u = -1;
        do {
            filesize /= thresh;
            ++u;
        } while(Math.abs(filesize) >= thresh && u < units.length - 1);
        return filesize.toFixed(1)+' '+units[u];
        // return fileSize(filesize).human()
    }

    formatMilli(milliseconds: any) {
        return convertMilli(parseInt(milliseconds))
    }
}
